'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var theme1 = '#a9be3b|#558cc0|#d34957|#ff9f3a|#968f8f|#b7409f|#ffda64|#4fbdae|#b78040|#676767|#6a33cf|#4a7833'.split('|');

exports.theme1 = theme1;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-charts-api/lib/util/colors/index.js
 ** module id = 227
 ** module chunks = 0 1
 **/